// ===========================================
// Consent API Functions
// ===========================================

import { apiClient } from '../services/api';

export type MediaExposure = 'PENDING' | 'NO' | 'BLUR' | 'FULL';

export interface AcknowledgeConsentPayload {
  termsAccepted: true;
  privacyAccepted: true;
  /** Primary contact only: a second contact agrees to the T&Cs + Privacy without it (#442). */
  mediaExposure?: Exclude<MediaExposure, 'PENDING'>;
}

export interface ConsentFamily {
  id: string;
  name: string;
  consentAccepted: boolean;
  consentAcceptedAt: string | null;
  consentDeclinedAt: string | null;
  mediaExposure: MediaExposure;
  mediaExposureSetAt: string | null;
}

/** A primary gets the family's consent back; a second contact gets `{ kind: 'CONTACT' }` (#442). */
export type AcknowledgeConsentResult = ConsentFamily | { kind: 'CONTACT' };

export async function acknowledgeConsent(
  familyId: string,
  payload: AcknowledgeConsentPayload
): Promise<AcknowledgeConsentResult> {
  const res = await apiClient.post<{ status: string; data: AcknowledgeConsentResult }>(
    `/families/${familyId}/consent/acknowledge`,
    payload
  );
  return res.data;
}

export async function declineConsent(familyId: string): Promise<void> {
  await apiClient.post(`/families/${familyId}/consent/decline`);
}

export async function updateMediaExposure(
  familyId: string,
  mediaExposure: Exclude<MediaExposure, 'PENDING'>
): Promise<ConsentFamily> {
  const res = await apiClient.patch<{ status: string; data: ConsentFamily }>(
    `/families/${familyId}/media-exposure`,
    { mediaExposure }
  );
  return res.data;
}
